<div class="form-container" fxLayout="column" fxLayoutAlign="start stretch">
  <div *ngIf="isLoading" class="loading" fxLayout="column"
    fxLayoutAlign="center center">
    <div class="spinner"></div>
    <p>Carregando Formulário...</p>
  </div>

  <div *ngIf="!isLoading" fxLayout="column" fxLayoutGap="24px"
    class="form-content" fxFill>
    <div *ngIf="formImage" class="image-container"
      fxLayoutAlign="center center">
      <img [src]="formImage || 'assets/img/wazir/wazir-icon.svg'"
        alt="Logo do formulário" />
    </div>

    <h2 class="form-title" fxLayoutAlign="center center">Responder
      Formulário</h2>

    <form [formGroup]="responseForm" (ngSubmit)="submitForm()" fxLayout="column"
      fxLayoutGap="28px">
      <div class="section form-section" *ngIf="selectedFields.length > 0"
        fxLayout="column" fxLayoutGap="16px">
        <h3 class="section-title">Informações Básicas</h3>
        <div class="input-fields" fxLayout="column" fxLayoutGap="16px">
          <div *ngFor="let field of selectedFields" class="form-field"
            fxFlex="100">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ field.label }}</mat-label>
              <input matInput type="text" [formControlName]="field.name"
                [required]="field.required" />
              <mat-error
                *ngIf="responseForm.get(field.name)?.invalid && responseForm.get(field.name)?.touched">
                Este campo é obrigatório
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="section form-section" *ngIf="checkboxFields.length > 0"
        fxLayout="column" fxLayoutGap="16px">
        <h3 class="section-title">Assuntos de Interesse</h3>
        <div class="checkbox-fields" fxLayout="row wrap"
          fxLayoutAlign="start start" fxLayoutGap="16px">
          <div fxFlex="calc(33.33% - 16px)" fxFlex.lt-md="calc(50% - 16px)"
            fxFlex.lt-sm="100%"
            *ngFor="let field of checkboxFields" class="checkbox-field">
            <mat-checkbox [formControlName]="field.name" color="primary">
              {{ field.label }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div class="section form-section" *ngIf="newQuestions.length > 0"
        fxLayout="column" fxLayoutGap="16px">
        <h3 class="section-title">Perguntas Adicionais</h3>
        <div class="custom-question-fields" fxLayout="column"
          fxLayoutGap="16px">
          <div *ngFor="let question of newQuestions; let i = index"
            class="form-field" fxFlex="100">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ question }}</mat-label>
              <input matInput type="text"
                [formControlName]="'customQuestion' + i" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="section form-section"
        *ngIf="extraQuestions && extraQuestions.length > 0" fxLayout="column"
        fxLayoutGap="16px">
        <h3 class="section-title">Suas Perguntas</h3>
        <div class="extra-question-fields" formArrayName="extraQuestions"
          fxLayout="column" fxLayoutGap="16px">
          <div *ngFor="let control of extraQuestions.controls; let i = index"
            class="form-field" fxFlex="100">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Digite sua pergunta {{ i+1 }}</mat-label>
              <input matInput type="text" [formControlName]="i"
                placeholder="O que você gostaria de perguntar?" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-actions" fxLayout="row" fxLayoutAlign="center center"
        fxLayoutGap="16px">
        <button mat-raised-button color="primary" type="submit"
          [disabled]="responseForm.invalid" class="submit-button">
          Enviar Formulário
        </button>
      </div>
    </form>
  </div>
</div>
